/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Qr_ButtonInputs */

const vi_grower_qr_button = /** @type {(inputs: Grower_Qr_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR số điện thoại`)
};

/**

* @param {Grower_Qr_ButtonInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_qr_button = /** @type {((inputs?: Grower_Qr_ButtonInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Qr_ButtonInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_qr_button(inputs)
});